import useAPI from "./useAPI";

export default function useAbis() {
  const api = useAPI();

  const adminAbis = async () => {
    return await api.getAdminAbis();
  };

  const adminAbiByName = async (name) => {
    return await api.getAdminAbi(name);
  };

  const adminCreateAbi = async ({ name, abi }) => {
    return await api.createAdminAbi({ name, abi });
  };

  const adminUpdateAbi = async (name, { abi }) => {
    return await api.updateAdminAbi(name, { abi });
  };

  const adminDeleteAbi = async (name) => {
    return await api.deleteAdminAbi(name);
  };

  const adminGenerateAbiFromSource = async (sourceCodeName) => {
    return await api.generateAdminAbiFromSource(sourceCodeName);
  };

  return {
    adminAbis,
    adminAbiByName,
    adminCreateAbi,
    adminUpdateAbi,
    adminDeleteAbi,
    adminGenerateAbiFromSource,
  };
}
